<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { AppShell, ToastList } from '@cavicode/network-ui';

const route = useRoute();
const standalone = computed(() => route.meta.standalone === true);
</script>

<template>
    <AppShell v-if="!standalone">
        <RouterView :key="route.path + ':' + (route.query.node ?? '')" />
    </AppShell>
    <RouterView v-else />
    <ToastList />
</template>
